import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import AtlasV2TrafficProductTable from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2TotalTraffic/AtlasV2TrafficProductTable';
import AtlasV2PaidTrafficSplineChart from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2PaidTraffic/AtlasV2PaidTrafficSplineChart';
import AtlasV2PaidTrafficShareChart from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2PaidTraffic/AtlasV2PaidTrafficShareChart';
import AtlasV2PaidTrafficByTopEntity from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2PaidTraffic/AtlasV2PaidTrafficByTopEntity';
import AtlasV2PaidTrafficAdSpendSplineChart from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2PaidTraffic/AtlasV2PaidTrafficAdSpendSplineChart';
import AtlasV2PaidTrafficAdSpendProductSplineChart from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2PaidTraffic/AtlasV2PaidTrafficAdSpendProductSplineChart';
import AtlasV2PaidTrafficProductsSplineChart from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2PaidTraffic/AtlasV2PaidTrafficProductsSplineChart';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';

/**
 * Atlas V2 Paid Traffic Page layout - Tab name: traffic subtab name: adClicks
 */
export const AtlasV2PaidTrafficPageLayout = () => {
  const { isProductEntity } = useProductEntity();
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  if (isRedirecting) return null;

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        {/* Paid Traffic  */}
        <AtlasV2PaidTrafficSplineChart />
        {/* Share of Paid Traffic */}
        <AtlasV2PaidTrafficShareChart />
        {/* Paid Traffic By Keyword TopEntity */}
        {!isProductEntity && <AtlasV2PaidTrafficByTopEntity />}
        {/* Paid Ad Spend */}
        <AtlasV2PaidTrafficAdSpendSplineChart />
        {/* Product with Paid Traffic */}
        {!isProductEntity && <AtlasV2PaidTrafficAdSpendProductSplineChart />}
        {/* Keyword Count with Paid Traffic */}
        <AtlasV2PaidTrafficProductsSplineChart />
        {/* Grid and Table */}
        <AtlasV2TrafficProductTable subtab="adClicks" />
      </Flex>
    </BasePageContainer>
  );
};
